import React from 'react';

import { Button as AntdButton } from 'antd';

import { useBaseFormContext } from 'components/BaseForm/BaseFormContext';
import { FilterDashboardJuridiction } from 'hooks/search/useSearchJuridictionQuery';

import './FormFooter.less';

interface FormActionProps {
  setFilter: (value: FilterDashboardJuridiction) => void;
}

export function FormFooter({ setFilter }: FormActionProps): React.ReactElement {
  const context = useBaseFormContext<FilterDashboardJuridiction>();

  function resetFilter() {
    context.setFieldsValue({
      idCorrelation: undefined,
      origineElement: undefined,
      numero: undefined,
      type: undefined,
      libelle: undefined,
      idCorrelationJuridictionParentes: undefined,
      codePostal: undefined,
      valid: true,
    });
  }

  return (
    <div className={'form-footer-container'}>
      <AntdButton onClick={resetFilter}>Réinitialiser</AntdButton>
      <AntdButton
        type={'primary'}
        onClick={() => setFilter(context.getFieldsValue())}
      >
        Rechercher
      </AntdButton>
    </div>
  );
}

export default FormFooter;
